import {useEffect, useRef} from "react"
import {useSelector} from "react-redux";


const FocusDetector = (props) => {


    /** global focus detector **/
    const accessible = useSelector(state => state.accessible);
    const assets = useSelector(state => state.assetsLoaded);
    const mousedown = useRef(false);

    useEffect(()=>{

        function setMouseDownTrue(){ mousedown.current = true }
        function setMouseDownFalse(){ setTimeout(()=>{ mousedown.current = false}, 100) }

        function applyRing(e){
            if(!mousedown.current) e.currentTarget.style.outline = 'auto';
        }

        function removeRing(e){ e.currentTarget.style.outline = 'none' }

        let buttons = document.querySelectorAll('*[role=button],*[role=link],*[role=checkbox],a');

        buttons.forEach((button)=>{
            button.addEventListener('focusin', applyRing);
            button.addEventListener('focusout', removeRing);
        })

        window.addEventListener('mousedown', setMouseDownTrue);
        window.addEventListener('mouseup', setMouseDownFalse);

        return ()=>{
            window.removeEventListener('mousedown', setMouseDownTrue);
            window.removeEventListener('mouseup', setMouseDownFalse);
            buttons.forEach((button)=>{
                button.addEventListener('focusin', applyRing);
                button.addEventListener('focusout', removeRing);
            })
        }

    },[accessible, assets.assetsLoaded]);

    return <></>;

}

export default FocusDetector;



